
import axios from 'axios';

export default async function UploadFileToS3(messageApi,file, product_id,media_id,media_type, setUploadStatus){
    try {
        if (messageApi != null){
        try{

          messageApi.open({
            type: 'loading',
            content: 'Uploading, Please wait...',
            duration: 0,
            key: 'payment-process'
          });

        }
        catch(e){
        }
      
    }
      let prod_url = `https://4iav7nkzgsu2jbpidrdt7seiri0lcfhk.lambda-url.ap-south-1.on.aws/generate_image_url?product_id=${product_id}&shop=true&media_id=${media_id}&media_type=${media_type}`

      const presSignedResponse = await axios.get(prod_url, {
        headers:{
          "Authorization" : localStorage.getItem("token")
        }
      });

        const signedUrl = presSignedResponse.data.url;
        
        const response = await axios.put(signedUrl, file, {
          headers: {
            'Content-Type': file.type,
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            if(setUploadStatus){
              setUploadStatus(percentCompleted)
            }
            // console.log(`Upload Progress: ${percentCompleted}%`);
          },
        });


      if (response.status === 200) {
        // console.log("putting  file 200")
        // console.log('File uploaded successfully');
       if(messageApi != null){
        messageApi.destroy()
        messageApi.success("File uploaded successfully")
       }
        
        let url  = signedUrl.replace("https://public-bucket-v3.s3.amazonaws.com/", "https://public-assets.instantdm.com/")
        
        url = url.split('?')
        return url[0]


      } else {
        // console.log("putting  file", response)
        // console.log('Error uploading file');
        if(messageApi != null){
        messageApi.destroy()
        // message.error("Failed to upload")
        }
      }
    } catch (error) {
      // console.log('Error uploading file:', error);
      if(messageApi != null){
        messageApi.destroy()
        // message.error("Failed to upload")
        }
    }
    return undefined
  };